<template>
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Usuário
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Manipule as informações do usuário
        </span>
      </h3>
      <div class="card-toolbar"></div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-2 pb-0">
      <b-form style="margin-bottom: 20px">
        <b-alert show variant="warning" v-if="inativoData">
          Usuário Inativo em {{ inativoData }}<br />
          Motivo: {{ inativoMotivo }}
        </b-alert>

        <b-form-group label="Usuário Vinculado:">
          <b-form-select
            v-model="usuarioSelecionado"
            :options="usuariosEmitentesFiltrados"
            @change="selecionarUsuarioObj"
            :disabled="!!idEmitenteMLUsuario"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="Nome:">
          <b-form-input
            type="text"
            v-model="usuarioSelecionadoObj.NOME"
            placeholder="Nome do usuário"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group label="CPF:">
          <b-form-input
            type="text"
            v-model="usuarioSelecionadoObj.CPF"
            placeholder="CPF do usuário"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group label="E-mail:">
          <b-form-input
            type="text"
            v-model="email"
            placeholder="E-mail do usuário"
            :disabled="!!idEmitenteMLUsuario"
            @blur="verificaEmailLivre"
          ></b-form-input>
        </b-form-group>

        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Permissões Paylogos:">
              <b-form-checkbox
                size="lg"
                v-model="permissoes.paylogos.dashboardPagar"
                name="permissoes-dashboard-pagar"
                :unchecked-value="false"
                :value="true"
              >
                Dashboard Pagar
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.paylogos.pagar"
                name="permissoes-pagar"
                :unchecked-value="false"
                :value="true"
              >
                Pagar
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.paylogos.dashboardReceber"
                name="permissoes-dashboard-receber"
                :unchecked-value="false"
                :value="true"
              >
                Dashboard Receber
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.paylogos.receber"
                name="permissoes-receber"
                :unchecked-value="false"
                :value="true"
              >
                Receber
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.paylogos.configuracoes"
                name="permissoes-configuracoes"
                :unchecked-value="false"
                :value="true"
              >
                Configurações
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group label="Permissões Consolebot:">
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.dashboard"
                name="permissoes-consolebot-dashboard"
                :unchecked-value="false"
                :value="true"
              >
                Dashboard
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.relatorios"
                name="permissoes-consolebot-relatorios"
                :unchecked-value="false"
                :value="true"
              >
                Relatórios
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.envios"
                name="permissoes-consolebot-envios"
                :unchecked-value="false"
                :value="true"
              >
                Envios
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.paylogos"
                name="permissoes-consolebot-paylogos"
                :unchecked-value="false"
                :value="true"
              >
                Paylogos
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.configuracoes"
                name="permissoes-consolebot-configuracoes"
                :unchecked-value="false"
                :value="true"
              >
                Configurações
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.integracoes"
                name="permissoes-consolebot-integracoes"
                :unchecked-value="false"
                :value="true"
              >
                Integrações
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.cadastros"
                name="permissoes-consolebot-cadastros"
                :unchecked-value="false"
                :value="true"
              >
                Cadastros
              </b-form-checkbox>
              <b-form-checkbox
                size="lg"
                v-model="permissoes.consolebot.cadastrosWeb"
                name="permissoes-consolebot-cadastrosweb"
                :unchecked-value="false"
                :value="true"
              >
                Cadastros Web
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Permissões Security:">
              <b-form-checkbox
                size="lg"
                v-model="permissoes.security"
                name="permissoes-security"
                :unchecked-value="false"
                :value="true"
              >
                Gerenciar Usuários e Logs
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>

        <div
          class="row"
          v-if="quantidadeTentativas > 0"
          style="margin-bottom: 22px"
        >
          <div class="col-md-12">
            Esse usuário teve
            <b>{{ quantidadeTentativas }}</b> tentativas de acesso sem sucesso.
            <br />
            <b-button
              class="margin-btn-5"
              @click="zerarTentativas"
              variant="info"
              :disabled="carregando"
              style="margin-top: 5px"
            >
              <b-spinner
                v-if="carregando"
                small
                style="margin-bottom: 2px; margin-right: 3px"
              ></b-spinner>
              Zerar Tentativas
            </b-button>
          </div>
        </div>

        <b-button
          class="margin-btn-5"
          @click="salvar"
          variant="primary"
          :disabled="!email || carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Salvar
        </b-button>
        <b-button
          v-if="!inativoData && $route.params.id"
          class="margin-btn-5"
          @click="inativar"
          variant="warning"
          :disabled="carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Inativar
        </b-button>
        <b-button
          v-if="inativoData"
          class="margin-btn-5"
          @click="ativar"
          variant="info"
          :disabled="carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Ativar
        </b-button>
        <b-button
          class="margin-btn-5"
          @click="voltar"
          variant="danger"
          :disabled="carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Voltar
        </b-button>
      </b-form>
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss">
.margin-btn-5 {
  margin-right: 5px;
}

.swal2-popup .swal2-content {
  margin-bottom: 2rem;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "Usuario",
  data() {
    return {
      idEmitenteMLUsuario: "",
      usuarioSelecionado: "",
      usuarioSelecionadoObj: {},
      email: "",
      inativoData: "",
      inativoMotivo: "",
      carregando: false,
      permissoes: {
        paylogos: {
          dashboardPagar: false,
          pagar: false,
          dashboardReceber: false,
          receber: false,
          configuracoes: false
        },
        consolebot: {
          dashboard: false,
          relatorios: false,
          envios: false,
          paylogos: false,
          configuracoes: false,
          integracoes: false,
          cadastros: false,
          cadastrosWeb: false
        },
        security: false
      },
      quantidadeTentativas: 0
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Gerenciar Usuário" }]);

    this.obterUsuario();
  },
  computed: {
    ...mapGetters(["verificado", "usuariosEmitente", "usuario"]),
    usuariosEmitentesFiltrados() {
      if (this.usuariosEmitente) {
        if (this.usuariosEmitente.length) {
          let usuarios = [];

          this.usuariosEmitente.forEach(function(usuario) {
            usuarios.push(usuario.USUARIO);
          });

          return usuarios.sort();
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapActions([
      "getUsuario",
      "getUsuariosEmitente",
      "updateUsuariosEmitente",
      "verificarEmailLivre",
      "inativarUsuario",
      "zerarQuantidadesTentativas"
    ]),
    async buscarUsuariosEmitente() {
      let vm = this;

      await vm.getUsuariosEmitente(vm.$route.params.id);

      if (vm.$route.params.id) {
        await vm.getUsuario(vm.$route.params.id);

        vm.idEmitenteMLUsuario = vm.usuario.ID_EMITENTE_ML_USUARIO;
        vm.usuarioSelecionado = vm.usuario.USUARIO;
        vm.email = vm.usuario.EMAIL;

        if (vm.usuario.INATIVO) {
          vm.inativoData = moment(
            vm.usuario.INATIVO,
            "YYYY-MM-DD HH:mm:ss"
          ).format("DD/MM/YYYY");
          vm.inativoMotivo = vm.usuario.INATIVO_MOTIVO;
        } else {
          vm.inativoData = "";
          vm.inativoMotivo = "";
        }

        vm.quantidadeTentativas = vm.usuario.QUANTIDADE_TENTATIVAS;

        vm.usuario.PERMISSOES.forEach(function(permissao) {
          let value = permissao.PERMISSAO == 1 ? true : false;

          switch (permissao.CODIGO) {
            case "SECURITY":
              vm.permissoes.security = value;
              break;
            case "PAYLOGOS_PAGAR":
              vm.permissoes.paylogos.pagar = value;
              break;
            case "PAYLOGOS_RECEBER":
              vm.permissoes.paylogos.receber = value;
              break;
            case "PAYLOGOS_RECEBER_DASHBOARD":
              vm.permissoes.paylogos.dashboardReceber = value;
              break;
            case "PAYLOGOS_PAGAR_DASHBOARD":
              vm.permissoes.paylogos.dashboardPagar = value;
              break;
            case "PAYLOGOS_CONFIGURACOES":
              vm.permissoes.paylogos.configuracoes = value;
              break;
            case "CONSOLEBOT_DASHBOARD":
              vm.permissoes.consolebot.dashboard = value;
              break;
            case "CONSOLEBOT_RELATORIOS":
              vm.permissoes.consolebot.relatorios = value;
              break;
            case "CONSOLEBOT_ENVIOS":
              vm.permissoes.consolebot.envios = value;
              break;
            case "CONSOLEBOT_PAYLOGOS":
              vm.permissoes.consolebot.paylogos = value;
              break;
            case "CONSOLEBOT_CONFIGURACOES":
              vm.permissoes.consolebot.configuracoes = value;
              break;
            case "CONSOLEBOT_INTEGRACOES":
              vm.permissoes.consolebot.integracoes = value;
              break;
            case "CONSOLEBOT_CADASTROS":
              vm.permissoes.consolebot.cadastros = value;
              break;
            case "CONSOLEBOT_CADASTROSWEB":
              vm.permissoes.consolebot.cadastrosWeb = value;
              break;
          }
        });

        vm.$nextTick(() => {
          vm.selecionarUsuarioObj();
          vm.carregando = false;
        });
      } else {
        vm.carregando = false;
      }
    },
    obterUsuario() {
      let vm = this;

      this.carregando = true;

      if (this.verificado) {
        this.buscarUsuariosEmitente();
      } else {
        window.addEventListener(
          "autorizado",
          function() {
            vm.buscarUsuariosEmitente();
          },
          false
        );
      }
    },
    selecionarUsuarioObj() {
      let vm = this;

      this.usuariosEmitente.forEach(function(usuario) {
        if (vm.usuarioSelecionado == usuario.USUARIO) {
          vm.usuarioSelecionadoObj = usuario;
        }
      });
    },
    voltar() {
      this.$router.push("/usuarios");
    },
    async salvar() {
      if (!this.usuarioSelecionado) {
        Swal.fire({
          title: "",
          text: "É necessário associar um usuário.",
          icon: "warning",
          showConfirmButton: false,
          timer: 2000
        });
      } else {
        this.carregando = true;

        await this.updateUsuariosEmitente({
          ID_EMITENTE_ML_USUARIO: this.idEmitenteMLUsuario,
          USUARIO: this.usuarioSelecionado,
          EMAIL: this.email,
          SECURITY: this.permissoes.security,
          PAYLOGOS_RECEBER_DASHBOARD: this.permissoes.paylogos.dashboardReceber,
          PAYLOGOS_RECEBER: this.permissoes.paylogos.receber,
          PAYLOGOS_PAGAR_DASHBOARD: this.permissoes.paylogos.dashboardPagar,
          PAYLOGOS_PAGAR: this.permissoes.paylogos.pagar,
          PAYLOGOS_CONFIGURACOES: this.permissoes.paylogos.configuracoes,
          CONSOLEBOT_DASHBOARD: this.permissoes.consolebot.dashboard,
          CONSOLEBOT_RELATORIOS: this.permissoes.consolebot.relatorios,
          CONSOLEBOT_ENVIOS: this.permissoes.consolebot.envios,
          CONSOLEBOT_PAYLOGOS: this.permissoes.consolebot.paylogos,
          CONSOLEBOT_CONFIGURACOES: this.permissoes.consolebot.configuracoes,
          CONSOLEBOT_INTEGRACOES: this.permissoes.consolebot.integracoes,
          CONSOLEBOT_CADASTROS: this.permissoes.consolebot.cadastros,
          CONSOLEBOT_CADASTROSWEB: this.permissoes.consolebot.cadastrosWeb
        });

        this.carregando = false;

        await Swal.fire({
          title: "",
          text: "Enviado com sucesso.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary"
        });

        this.$router.push("/usuarios");
      }
    },
    verificaEmailLivre() {
      let vm = this;

      this.carregando = true;
      this.verificarEmailLivre(this.email).then(function(result) {
        vm.carregando = false;

        if (!result.resultado) {
          vm.email = "";

          Swal.fire({
            title: "",
            text: "O e-mail já está sendo utilizado em outro usuário.",
            icon: "error",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    ativar() {
      let vm = this;

      vm.carregando = true;
      vm.inativarUsuario({
        ID_EMITENTE_ML_USUARIO: vm.idEmitenteMLUsuario,
        INATIVO_MOTIVO: ""
      }).then(function() {
        Swal.fire({
          title: "",
          text: "O usuário foi ativado com sucesso.",
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });

        vm.obterUsuario();
        vm.carregando = false;
      });
    },
    inativar() {
      let vm = this;

      Swal.fire({
        title: "Por favor digite o motivo da inativação:",
        input: "text",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Enviar",
        showLoaderOnConfirm: true,
        preConfirm: function(motivo) {
          if (!motivo) {
            Swal.showValidationMessage(
              "Não é possível enviar o motivo da inativação em branco."
            );
          } else {
            vm.carregando = true;
            vm.inativarUsuario({
              ID_EMITENTE_ML_USUARIO: vm.idEmitenteMLUsuario,
              INATIVO_MOTIVO: motivo
            }).then(function() {
              Swal.fire({
                title: "",
                text: "O usuário foi inativado com sucesso.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000
              });

              vm.carregando = false;
              vm.obterUsuario();
            });
          }
        }
      });
    },
    zerarTentativas() {
      let vm = this;

      vm.carregando = true;

      vm.zerarQuantidadesTentativas({
        ID_EMITENTE_ML_USUARIO: vm.idEmitenteMLUsuario
      }).then(function() {
        Swal.fire({
          title: "",
          text:
            "A quantidade de tentativas desse usuário foi zerada com sucesso.",
          icon: "success",
          showConfirmButton: false,
          timer: 3000
        });

        vm.carregando = false;
        vm.obterUsuario();
      });
    }
  }
};
</script>
